import React from "react";
import ReactDOM from 'react-dom/client';
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import { BrowserRouter } from "react-router-dom";
import "./i18n";
import { Provider } from "react-redux";
import store from "./store";
import resizeObserverErrorHandler from './utils/resizeObserverErrorHandler';

// Initialize the ResizeObserver error handler
const cleanupErrorHandler = resizeObserverErrorHandler();

// Clean up the error handler when the app is unmounted
if (typeof window !== 'undefined') {
  window.addEventListener('beforeunload', cleanupErrorHandler);
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
    <Provider store={store}>
      <React.Fragment>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </React.Fragment>
    </Provider>
);

serviceWorker.unregister()
